module.exports = __webpack_public_path__ + "static/powerlogo-0cb0a169d5609895b6ebc98e917ed79a.svg";